import { createContext, useContext, useState, useEffect, ReactNode } from 'react'
import { useAuthContext } from '@/context'
import { useQueryBrandVoices } from '@/services/brand-voices/queries'
import { BrandVoiceType } from '@/types/brand-voice'

/* eslint-disable react-refresh/only-export-components -- context module */

interface BrandVoiceContextProps {
    brandVoices: BrandVoiceType[] | null
    loading: boolean
}

export const BrandVoiceContext = createContext<BrandVoiceContextProps>({
    brandVoices: null,
    loading: true,
})

export const BrandVoiceProvider = ({ children }: { children: ReactNode }) => {
    const { org } = useAuthContext()
    const [brandVoices, setBrandVoices] = useState<BrandVoiceType[] | null>(null)
    const [loading, setLoading] = useState(true)

    const { data, isLoading } = useQueryBrandVoices({
        enabled: !!org?.id,
        queryParams: {
            org: org?.id as string,
        },
    })

    useEffect(() => {
        if (!isLoading) {
            setBrandVoices(data || null)
            setLoading(false)
        }
    }, [data, isLoading])

    return <BrandVoiceContext.Provider value={{ brandVoices, loading }}>{children}</BrandVoiceContext.Provider>
}

export const useBrandVoiceContext = () => useContext(BrandVoiceContext)
